import React, { useRef, useState } from "react";
import { BootstrapModal } from "../../../BootstrapModal/Modal";
import styled from "styled-components";
import { CgClose } from "react-icons/cg";
import Button from "../../../Button/Button";
import {
  useUpdateCategoryLevel,
  useGetProductList1,
  useGetProductList2,
} from "../../../../hooks/useContent";
import {
  RefreshTableLevel3,
  ContentUnitModal,
} from "../../../../shared/content-unit";
import { useRecoilState } from "recoil";
import {
  RowElement,
  RowLayoutStyle,
} from "../../../ContentUnit/Sliders/AddSlide";
import { InputField1 } from "../../../InputField1/InputField1";
import Spinner from "react-bootstrap/Spinner";
import Typography from "../../../Typography/Typography";
import { errorMessage } from "../../../../utils/message";
import { SimpleSelect1 } from "../../../SimpleSelect/SimpleSelect1";
import Editor from "../../../../core/components/textEditor/Editor";

function EditLevel3({ show, handleClose }) {
  const {
    mutateAsync: updateProperty,
    isLoading: reqLoading,
    isError: reqError,
  } = useUpdateCategoryLevel();
  const [refreshEffect, setRefreshEffect] = useRecoilState(RefreshTableLevel3);
  const [updateState, setUpdateState] = useRecoilState(ContentUnitModal);

  const {
    data: productList2,
    refetch: refetchList,
    isLoading: isloadingProduct2,
    error: errorTow,
  } = useGetProductList2("", "");

  const [initialValues, setValueForm] = useState({
    name: updateState.updateLevel3.value.NameCategories
      ? updateState.updateLevel3.value?.NameCategories
      : "",
    en_name: updateState.updateLevel3.value.NameEnglishCategories
      ? updateState.updateLevel3.value?.NameEnglishCategories
      : "",
    ar_name: updateState.updateLevel3.value.NameLanguageCategories
      ? updateState.updateLevel3.value?.NameLanguageCategories
      : "",
    slug: updateState.updateLevel3.value?.SlugCategories
      ? updateState.updateLevel3.value?.SlugCategories
      : "",
    en_slug: updateState.updateLevel3.value?.SlugEnglishCategories
      ? updateState.updateLevel3.value?.SlugEnglishCategories
      : "",
    ar_slug: updateState.updateLevel3.value?.SlugLanguageCategories
      ? updateState.updateLevel3.value?.SlugLanguageCategories
      : "",
    desc: updateState.updateLevel3.value.DescriptionCategories
      ? updateState.updateLevel3.value?.DescriptionCategories
      : "",
    aikenCategories: "",
    darkIcon: updateState.updateLevel3.value.AikenCategoriesSvgDark
      ? updateState.updateLevel3.value?.AikenCategoriesSvgDark
      : "",
    lightIcon: updateState.updateLevel3.value.AikenCategoriesSvgLight
      ? updateState.updateLevel3.value?.AikenCategoriesSvgLight
      : "",
    category_id: updateState.updateLevel3.value.IdCategories
      ? updateState.updateLevel3.value.IdCategories
      : "",
    level: "2",
  });

  const { data, refetch, isLoading, error } = useGetProductList1("");

  let selectOptions = data?.data?.categories?.map((cat) => {
    return { value: cat.IdCategories, label: cat.NameCategories };
  });

  const [description, setDescription] = useState(initialValues.desc);

  const defaultOption = useState({
    value: -1,
    label: "کشور والد را انتخاب کنید",
  });
  const inputSelect = useRef();

  const [parentId, setParentId] = useState(
    updateState?.updateLevel3?.value?.parent?.IdCategories
  );

  const isValidImg = (event) => {
    let isValid = true;

    const file = event.target.files[0];
    if (
      file.type !== "image/png" &&
      file.type !== "image/jpg" &&
      file.type !== "image/jpeg"
    ) {
      errorMessage("فایل انتخاب شده صحیح نیست");
      isValid = false;
      event.target.value = "";
    }
    return isValid;
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    if (e.target?.type === "file") {
      const file = e.target.files[0];
      if (isValidImg(e)) {
        setValueForm({ ...initialValues, [name]: file });
      } else setValueForm({ ...initialValues, [name]: "" });

      return 3;
    }

    setValueForm({
      ...initialValues,
      [name]: value,
    });
  };

  const validateForm = () => {
    if (initialValues.name.length < 1) {
      errorMessage("لطفا نام فارسی دسته بندی را وارد کنید");
      return false;
    } else if (parentId === -1) {
      errorMessage("لطفا سطح دسته بندی 2 را انتخاب کنید");
      return false;
    } else if (initialValues.slug.length < 1) {
      errorMessage("لطفا لینک فارسی را وارد نمایید");
      return false;
    } else if (initialValues.en_slug.length < 1) {
      errorMessage("لطفا لینک انگلیسی را وارد کنید");
      return false;
    } else if (initialValues.ar_slug.length < 1) {
      errorMessage("لطفا لینک عربی را وارد کنید");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const formData = new FormData();

      formData.append("name", initialValues.name);
      formData.append("level", initialValues.level);
      formData.append("lightIcon", initialValues.lightIcon);
      formData.append("darkIcon", initialValues.darkIcon);
      formData.append("en_name", initialValues.en_name);
      formData.append("ar_name", initialValues.ar_name);
      formData.append("desc", description);
      formData.append("aikenCategories", initialValues.aikenCategories);
      formData.append("category_id", initialValues.category_id);
      formData.append("parent_id", parentId);
      formData.append("slug", initialValues.slug.replaceAll(" ", "-"));
      formData.append("en_slug", initialValues.en_slug.replaceAll(" ", "-"));
      formData.append("ar_slug", initialValues.ar_slug.replaceAll(" ", "-"));
      updateProperty(formData).then((res) => {
        setDescription("");
        setRefreshEffect(!refreshEffect);
        handleClose();
      });
    }
  };

  const handleChangeSelectMode = (e) => {
    const { value } = e ?? -1;
    setParentId(value);
  };

  const [selectOption2, setSelectOption2] = useState(
    productList2?.pages[0]?.data?.CategoriesLevelTwo
      ? productList2?.pages[0]?.data?.CategoriesLevelTwo?.filter(
          (cat) =>
            cat?.parent?.IdCategories ===
            updateState?.updateLevel3?.value?.parent?.IdWaledCategories
        )?.map((dat) => {
          return { value: dat?.IdCategories, label: dat?.NameCategories };
        })
      : []
  );

  const [defaultPlaceHolder, setDefaultHolder] = useState(
    "سطح 2 را انتخاب کنید"
  );

  const handleChangeLevel1 = (e) => {
    const { value } = e ?? -1;
    setParentId(-1);

    setDefaultHolder("سطح 2 را  انتخاب کنید ");

    const filterData = productList2?.pages[0]?.data?.CategoriesLevelTwo?.filter(
      (cat) => cat?.parent?.IdCategories === value
    );

    setSelectOption2(
      filterData?.map((cat) => {
        return { value: cat.IdCategories, label: cat.NameCategories };
      })
    );
  };

  return (
    <BootstrapModal
      show={show}
      handleClose={handleClose}
      modaltitle={"ویرایش دسته بندی"}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <UpdateCategoryStyle>
        <RowElementDiv>
          <SimpleSelect1
            inputRef={inputSelect}
            label={"سطح 3 دسته بندی"}
            onChange={handleChangeLevel1}
            placeholder={
              data?.data?.categories.filter(
                (cat) =>
                  cat?.IdCategories ===
                  updateState?.updateLevel3?.value?.parent?.IdWaledCategories
              )[0]?.NameCategories
            }
            res={selectOptions}
          />
          <SimpleSelect1
            label={"سطح 3 دسته بندی"}
            onChange={handleChangeSelectMode}
            placeholder={
              updateState?.updateLevel3?.value?.parent?.NameCategories
            }
            res={selectOption2}
          />
          <InputField1
            type="text"
            name="name"
            label="نام فارسی"
            onChange={handleChange}
            value={initialValues?.name}
            placeholder="نام فارسی دسته بندی.."
            maxLenght="50"
          />
          <InputField1
            type="text"
            name="en_name"
            label="نام انگلیسی"
            onChange={handleChange}
            value={initialValues?.en_name}
            placeholder="نام انگلیسی دسته بندی..."
            maxLenght="50"
          />
          <InputField1
            type="text"
            name="ar_name"
            label="نام عربی"
            onChange={handleChange}
            value={initialValues?.ar_name}
            placeholder="نام دسته بندی عربی ..."
            maxLenght="50"
          />
        </RowElementDiv>
        <RowColumn>
          <InputField1
            type="text"
            name="slug"
            label="url فارسی"
            onChange={handleChange}
            value={initialValues?.slug}
            placeholder="لینک فارسی.."
          />

          <InputField1
            type="text"
            name="en_slug"
            label="url انگلیسی"
            onChange={handleChange}
            value={initialValues?.en_slug}
            placeholder="لینک انگلیسی.."
          />

          <InputField1
            type="text"
            name="ar_slug"
            label="url  عربی"
            onChange={handleChange}
            value={initialValues?.ar_slug}
            placeholder="لینک عربی..."
            maxLenght="50"
          />
        </RowColumn>
        <InputField1
          type="file"
          name="aikenCategories"
          label="عکس"
          onChange={handleChange}
          placeholder="عکس منو گوشی.."
          maxLenght="50"
        />
        <RowLayoutStyle>
          <InputField1
            type="text"
            name="darkIcon"
            label="ایکن مشکی"
            onChange={handleChange}
            value={initialValues?.darkIcon}
            placeholder="ایکن مشکی ..."
          />
          <InputField1
            type="text"
            name="lightIcon"
            label="ایکن رنگی"
            onChange={handleChange}
            value={initialValues?.lightIcon}
            placeholder="ایکن رنگی..."
          />
        </RowLayoutStyle>
        <RowColumn>
          <InputField1
            type="text"
            name="productLabel"
            label="لیبل محصول"
            onChange={handleChange}
            value={initialValues?.productLabel}
            placeholder="لیبل"
            maxLenght="50"
          />
        </RowColumn>
        <Editor state={description} setState={setDescription} />

        <Button
          bgColor={"#4c78a9"}
          small={"100px"}
          className="m-r-1"
          onclick={(e) => {
            !reqLoading && handleSubmit();
          }}
          color="#fff"
        >
          {reqLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Typography size={"15px"} primary={"#fff"}>
              ویرایش
            </Typography>
          )}
        </Button>
        <Button
          className={"mr-2"}
          style={{ marginRight: "10px" }}
          color={"#fff"}
          bgColor={"#f1416c"}
          small={"100px"}
          onclick={handleClose}
        >
          <Typography size={"15px"} primary={"#fff"}>
            انصراف
          </Typography>
        </Button>
      </UpdateCategoryStyle>
    </BootstrapModal>
  );
}

const UpdateCategoryStyle = styled.div``;

const RowElementDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  row-gap: 1rem;
  column-gap: 1rem;
`;

const RowColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export default EditLevel3;
